import {
    CanceledIcon,
    NedMoreInfoIcon,
    RejectedIcon,
    WaitingForCarrierWarningBigIcon,
} from 'src/components/SkladonIcon/StatusIcons';
import { getStatusIcon as getOrderStatusIcon, getStatusIconComponent } from '../OrderDetailContainer/functions';
import { TableRowType } from 'src/types/table';

const getStatusIcon = (row: TableRowType): JSX.Element | null => {
    switch (row.SECTION) {
        case 'ORDER':
            return getOrderStatusIcon(row.STATUS);

        case 'RECEIVING':
            switch (row.STATUS) {
                case 'received':
                    return getStatusIconComponent('received', 'success');
                case 'canceled':
                    return <CanceledIcon />;
                case 'awaiting':
                    return <WaitingForCarrierWarningBigIcon />;
                case 'confirmed':
                    return getStatusIconComponent('processing', 'success');
            }
            break;

        case 'CLAIM':
            switch (row.STATUS) {
                case 'inProcess':
                    return getStatusIconComponent('processing', 'success');
                case 'rejected':
                    return <RejectedIcon />;
                case 'moreInfoNeeded':
                    return <NedMoreInfoIcon />;
            }
            break;
        default:
    }
    return null;
};

export default getStatusIcon;
